import { action } from 'satcheljs';

/**
 * Action to set isSearchHistoryDirty to a desired value in the search store
 * @param isSearchHistoryDirty the new desired value
 */
export default action(
    'setIsSearchHistoryDirty',
    function setIsSearchHistoryDirty(isSearchHistoryDirty: boolean) {
        return { isSearchHistoryDirty };
    }
);
